import { Observable } from 'rxjs';
import { Socio } from '../../../domain/models/socio.model';
import { Create } from '../../../domain/repositories/general/create.interface';
import { CRUDHnadler } from '../../../domain/repositories/general/crud.handler';

/**
 * Casos de uso de la entidad Socio que realizara acciones a nivel de aplicación cuando se realice la acción de creación 

 *
 * @export
 * @class CreateSocioUseCase
 * @implements {Create}
 */
export class CreateSocioUseCase implements Create {
  constructor(private crudHandler: CRUDHnadler) {}

  public create(socio: Socio): Observable<Socio> {
    return this.crudHandler.save(socio);
  }
}
